import { useMaintenanceCheck, MaintenanceScreen } from '../MaintenanceGate';
import { LeaveRosterEntry } from '../LeaveRoster';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const GMAPS_KEY = 'AIzaSyAopjtw19bW62Wo_DK7DxTzYAJ1HBWJhig';

function fmt(n) { if (n == null) return '—'; return Number(n).toLocaleString(); }
function esc(s) { if (s == null) return '—'; return String(s); }

function parseBool(v) {
  if (v === null || v === undefined || v === '') return null;
  if (v === true  || v === 'TRUE'  || v === 'true')  return true;
  if (v === false || v === 'FALSE' || v === 'false') return false;
  return null;
}

// Render a business_addresses entry — plain string or {address,type,status} object
function AddrRow({ addr, index, isFirst }) {
  const isObj = typeof addr === 'object' && addr !== null;
  const text  = isObj ? addr.address : addr;
  const label = isObj
    ? `Branch${addr.status ? ' (' + addr.status + ')' : ''}`
    : isFirst ? 'Registered' : 'Business';
  const color = isObj ? '#7b1fa2' : '#888';
  return (
    <div style={{ fontSize: 13, padding: '6px 0', borderBottom: '1px solid #f3f3f3', color: '#333' }}>
      <span style={{ color, fontSize: 11, marginRight: 8 }}>{label}</span>{text}
    </div>
  );
}

// Address comparison — handles mixed string/object array
function AddrCompareRow({ addr, index }) {
  const isObj = typeof addr === 'object' && addr !== null;
  const text  = isObj ? addr.address : addr;
  const label = isObj
    ? `Branch${addr.status ? ' (' + addr.status + ')' : ''}`
    : index === 0 ? 'Registered' : 'Business';
  const color = isObj ? '#7b1fa2' : '#888';
  return (
    <div style={{ fontSize: 13, color: '#333', lineHeight: 1.6, marginBottom: 6 }}>
      <span style={{ fontSize: 10, color, display: 'block' }}>{label}</span>
      {text}
    </div>
  );
}

const s = {
  page:      { minHeight: '100vh', background: '#f5f5f5' },
  nav:       { background: '#c8102e', padding: '14px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  navLeft:   { display: 'flex', alignItems: 'center', gap: 16 },
  navTitle:  { color: '#fff', fontWeight: 700, fontSize: 15 },
  backBtn:   { background: 'transparent', border: '1px solid rgba(255,255,255,0.4)', color: '#fff', padding: '5px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 12 },
  navUser:   { color: 'rgba(255,255,255,0.8)', fontSize: 13 },
  body:      { maxWidth: 860, margin: '0 auto', padding: '24px 20px 100px' },
  card:      { background: '#fff', borderRadius: 10, padding: '18px 20px', marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.07)' },
  cardTitle: { fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#888', marginBottom: 14 },
  grid2:     { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 20px' },
  kv:        { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '8px 0', borderBottom: '1px solid #f3f3f3', fontSize: 14, gap: 16 },
  kvLbl:     { color: '#666', minWidth: 140, flexShrink: 0 },
  kvVal:     { fontWeight: 600, textAlign: 'right', flex: 1, wordBreak: 'break-word' },
  photo:     { width: '100%', maxHeight: 500, objectFit: 'contain', borderRadius: 8, border: '1px solid #eee', background: '#f8f8f8' },
  decBar:    { position: 'fixed', bottom: 0, left: 0, right: 0, background: '#fff', borderTop: '1px solid #eee', padding: '14px 24px', display: 'flex', gap: 10, justifyContent: 'center', boxShadow: '0 -4px 16px rgba(0,0,0,0.08)', zIndex: 100 },
  btn:       { padding: '11px 24px', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  overlay:   { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 },
  modal:     { background: '#fff', borderRadius: 12, padding: 28, width: 460, boxShadow: '0 8px 32px rgba(0,0,0,0.2)', maxHeight: '90vh', overflowY: 'auto' },
  modalTitle:{ fontSize: 16, fontWeight: 700, marginBottom: 16 },
  label:     { display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, marginTop: 12, color: '#444' },
  input:     { width: '100%', padding: '9px 10px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' },
  textarea:  { width: '100%', padding: '9px 10px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14, resize: 'vertical', minHeight: 80, boxSizing: 'border-box' },
  select:    { width: '100%', padding: '9px 10px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14, background: '#fff', boxSizing: 'border-box' },
  modalBtns: { display: 'flex', gap: 8, marginTop: 16 },
  toggle:    { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f3f3f3' },
  toggleLbl: { fontSize: 14, color: '#333' },
  toggleBtn: { display: 'flex', gap: 6 },
};

function KV({ label, value }) {
  return (
    <div style={s.kv}>
      <span style={s.kvLbl}>{label}</span>
      <span style={{ ...s.kvVal, textAlign: 'right', maxWidth: '60%', wordBreak: 'break-word' }}>{value ?? '—'}</span>
    </div>
  );
}

function ToggleCheck({ label, value, onChange, readonly }) {
  return (
    <div style={s.toggle}>
      <span style={s.toggleLbl}>{label}</span>
      <div style={s.toggleBtn}>
        {[true, false].map(v => (
          <button key={String(v)} onClick={() => !readonly && onChange(v)} style={{
            padding: '5px 16px', borderRadius: 6, fontSize: 12, fontWeight: 600,
            border: 'none', cursor: readonly ? 'default' : 'pointer',
            background: value === v ? (v ? '#1e7e34' : '#c5221f') : '#eee',
            color: value === v ? '#fff' : '#999',
            opacity: readonly ? 0.75 : 1,
          }}>{v ? 'Pass' : 'Fail'}</button>
        ))}
      </div>
    </div>
  );
}

function OutletMap({ lat, lng, checkinPins }) {
  const mapRef     = useRef(null);
  const gMapRef    = useRef(null);
  const infoWinRef = useRef(null);
  const [mode, setMode]       = useState('map');
  const [svAvail, setSvAvail] = useState(true);
  const [loaded, setLoaded]   = useState(false);

  useEffect(() => {
    if (window.google?.maps) { setLoaded(true); return; }
    if (document.getElementById('gm-script')) {
      const check = setInterval(() => { if (window.google?.maps) { setLoaded(true); clearInterval(check); } }, 100);
      return () => clearInterval(check);
    }
    const sc = document.createElement('script');
    sc.id = 'gm-script';
    sc.src = `https://maps.googleapis.com/maps/api/js?key=${GMAPS_KEY}&libraries=geometry`;
    sc.async = true;
    sc.onload = () => setLoaded(true);
    document.head.appendChild(sc);
  }, []);

  const initMap = useCallback(() => {
    if (!mapRef.current || !window.google?.maps) return;
    const center = { lat: parseFloat(lat), lng: parseFloat(lng) };
    const map = new window.google.maps.Map(mapRef.current, {
      center, zoom: 18, mapTypeId: 'roadmap',
      streetViewControl: false, mapTypeControl: false, fullscreenControl: false,
    });
    gMapRef.current = map;
    const iw = new window.google.maps.InfoWindow();
    infoWinRef.current = iw;
    new window.google.maps.Marker({
      position: center, map,
      icon: { path: window.google.maps.SymbolPath.CIRCLE, scale: 10, fillColor: '#c8102e', fillOpacity: 1, strokeColor: '#fff', strokeWeight: 2 },
      zIndex: 10,
    });
    checkinPins.forEach((p, i) => {
      const pos    = { lat: parseFloat(p.geocode_lat), lng: parseFloat(p.geocode_lng) };
      const marker = new window.google.maps.Marker({
        position: pos, map,
        label: { text: String(i + 1), color: '#fff', fontSize: '11px', fontWeight: 'bold' },
        icon:  { path: window.google.maps.SymbolPath.CIRCLE, scale: 12, fillColor: '#1967d2', fillOpacity: 1, strokeColor: '#fff', strokeWeight: 2 },
      });
      const content = [
        `<strong style="color:#1967d2">Check-in ${i + 1}</strong>`,
        p.check_in_date  ? `📅 ${p.check_in_date}${p.check_in_time ? ' ' + p.check_in_time : ''}` : null,
        p.photo_type     ? `📷 ${p.photo_type.replace(/_/g, ' ')}` : null,
        p.signboard_text ? `🪧 "${p.signboard_text}"` : null,
      ].filter(Boolean).join('<br/>');
      marker.addListener('click',     () => { iw.setContent(`<div style="font-size:13px;line-height:1.7">${content}</div>`); iw.open(map, marker); });
      marker.addListener('mouseover', () => { iw.setContent(`<div style="font-size:13px;line-height:1.7">${content}</div>`); iw.open(map, marker); });
    });
    if (checkinPins.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend(center);
      checkinPins.forEach(p => bounds.extend({ lat: parseFloat(p.geocode_lat), lng: parseFloat(p.geocode_lng) }));
      map.fitBounds(bounds, { top: 40, bottom: 40, left: 40, right: 40 });
      window.google.maps.event.addListenerOnce(map, 'bounds_changed', () => { if (map.getZoom() > 18) map.setZoom(18); });
    }
  }, [lat, lng, checkinPins]);

  useEffect(() => { if (loaded && mode !== 'streetview') initMap(); }, [loaded, initMap]);
  useEffect(() => {
    if (!gMapRef.current) return;
    if (mode === 'map')       gMapRef.current.setMapTypeId('roadmap');
    if (mode === 'satellite') gMapRef.current.setMapTypeId('satellite');
  }, [mode, loaded]);
  useEffect(() => {
    if (!loaded || mode !== 'streetview' || !mapRef.current || !window.google?.maps) return;
    const center = { lat: parseFloat(lat), lng: parseFloat(lng) };
    new window.google.maps.StreetViewService().getPanorama({ location: center, radius: 100 }, (data, status) => {
      if (status !== 'OK') { setSvAvail(false); setMode('map'); return; }
      new window.google.maps.StreetViewPanorama(mapRef.current, { position: center, pov: { heading: 0, pitch: 0 }, zoom: 1, addressControl: false, fullscreenControl: false });
      gMapRef.current = null;
    });
  }, [loaded, mode, lat, lng]);
  useEffect(() => { if (loaded && mode !== 'streetview' && !gMapRef.current) initMap(); }, [loaded, mode, initMap]);

  const modeBtn = (key, label) => (
    <button key={key} onClick={() => setMode(key)} style={{
      padding: '5px 14px', borderRadius: 6, fontSize: 11, fontWeight: 600,
      cursor: 'pointer', border: 'none',
      background: mode === key ? '#c8102e' : '#eee',
      color: mode === key ? '#fff' : '#333',
    }}>{label}</button>
  );

  return (
    <div style={{ marginTop: 14 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>Location</div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 8, alignItems: 'center' }}>
        {modeBtn('map', '🗺 Map')}{modeBtn('satellite', '🛰 Satellite')}{modeBtn('streetview', '🚶 Street View')}
        <a href={`https://www.google.com/maps?q=${lat},${lng}&z=18`} target="_blank" rel="noopener noreferrer"
          style={{ marginLeft: 'auto', padding: '5px 12px', borderRadius: 6, fontSize: 11, fontWeight: 600, color: '#c8102e', textDecoration: 'none', background: '#fff0f0' }}>
          Open in Maps ↗
        </a>
      </div>
      <div ref={mapRef} style={{ width: '100%', height: 320, borderRadius: 8, border: '1px solid #eee', background: '#f0f0f0', overflow: 'hidden' }} />
      {!svAvail && <div style={{ fontSize: 11, color: '#b06000', marginTop: 4 }}>⚠ Street View not available</div>}
      {checkinPins.length > 0 && (
        <div style={{ marginTop: 8 }}>
          {checkinPins.map((p, i) => (
            <a key={i} href={`https://www.google.com/maps?q=${p.geocode_lat},${p.geocode_lng}&z=18`} target="_blank" rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '5px 10px', borderRadius: 6, fontSize: 12, background: '#e8f0fe', color: '#1967d2', textDecoration: 'none', fontWeight: 500, marginBottom: 4, width: 'fit-content' }}>
              <span style={{ background: '#1967d2', color: '#fff', borderRadius: '50%', width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 700 }}>{i + 1}</span>
              {p.check_in_date}{p.check_in_time ? ' ' + p.check_in_time : ''}
              {p.photo_type && <span style={{ color: '#5f6368' }}> · {p.photo_type.replace(/_/g, ' ')}</span>}
            </a>
          ))}
        </div>
      )}
      <div style={{ fontSize: 11, color: '#b06000', marginTop: 4 }}>⚠ Red = master coords (salesman-inputted) · Blue = verified check-in</div>
    </div>
  );
}

export default function KYCPage() {
  const { mcRow } = useParams();
  const { user, logout }  = useAuth();
  const maint = useMaintenanceCheck('approver');
  const navigate  = useNavigate();

  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [profileOpen, setProfileOpen] = useState(false);
  const [leaveModalOpen, setLeaveModalOpen] = useState(false);
  const [expandedHistorical, setExpandedHistorical] = useState(new Set());
  const [showAllPhotos, setShowAllPhotos] = useState(false);
  const [enlargedPhoto, setEnlargedPhoto] = useState(null);
  const [error, setError]     = useState('');
  const [modal, setModal]     = useState(false);
  const [saving, setSaving]   = useState(false);
  const [toast, setToast]     = useState({ msg: '', isError: false });
  const [dupMatches, setDupMatches]         = useState([]);   // amast matches with relation_type state
  const [manualExtraCount, setManualExtraCount] = useState(0);

  const [checks, setChecks] = useState({
    brn_check: null, entity_status: null, geocode_check: null,
    duplicate_check: null, duplicate_count: '', kyc_status: '', kyc_remarks: '',
  });
  const [signboardAck, setSignboardAck] = useState(false);

  useEffect(() => {
    fetch(`/api/assessments/${mcRow}`)
      .then(r => r.json())
      .then(d => {
        setData(d);
        // Load existing duplicate check decisions from context
        const dupCheck = d.context?.duplicate_check;
        if (dupCheck?.amast_matches) {
          setDupMatches(dupCheck.amast_matches);
          setManualExtraCount(dupCheck.manual_extra_count || 0);
        }
        if (d.kycChecks?.kyc_status) {
          setChecks({
            brn_check:       parseBool(d.kycChecks.brn_check),
            entity_status:   parseBool(d.kycChecks.entity_status),
            geocode_check:   parseBool(d.kycChecks.geocode_check),
            duplicate_check: parseBool(d.kycChecks.duplicate_check),
            duplicate_count: d.kycChecks.duplicate_count || '',
            kyc_status:      d.kycChecks.kyc_status      || '',
            kyc_remarks:     d.kycChecks.kyc_remarks      || '',
          });
        }
      })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [mcRow]);

  function showToast(msg, isError) {
    setToast({ msg, isError });
    setTimeout(() => setToast({ msg: '', isError: false }), isError ? 8000 : 3000);
  }

  function setCheck(key, val) { setChecks(prev => ({ ...prev, [key]: val })); }

  function allChecksComplete() {
    const { brn_check, entity_status, geocode_check, duplicate_check, duplicate_count, kyc_status } = checks;
    // Only require classification for matches that don't already have a
    // resolved relation_type — obligor_confirmed rows are pre-resolved and
    // don't need a fresh KYC decision (per Jun: already confirmed related
    // party listed in Obligor doesn't need to be reflagged).
    const hasDupMatches = dupMatches.length > 0;
    const dupClassified = !hasDupMatches || dupMatches.every(m =>
      m.relation_source === 'obligor_confirmed' || m.relation_type != null
    );
    return brn_check !== null && entity_status !== null && geocode_check !== null && duplicate_check !== null && duplicate_count !== '' && kyc_status !== '' && dupClassified && (!signboardMismatch || signboardAck);
  }

  async function handleSubmit() {
    setSaving(true);
    try {
      const today = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
      const [kycRes, dupRes] = await Promise.all([
        fetch(`/api/kyc/${mcRow}`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...checks, prepared_by: user.displayName, prepared_date: today }),
        }),
        dupMatches.length > 0 ? fetch(`/api/duplicate-check/${mcRow}`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ amast_matches: dupMatches, manual_extra_count: manualExtraCount, aiaRow: data.aiaSheetRow }),
        }) : Promise.resolve({ ok: true, json: () => ({ success: true }) }),
      ]);
      const result = await kycRes.json();
      if (result.success) { showToast('✓ KYC saved', false); setModal(false); setTimeout(() => navigate('/'), 1200); }
      else showToast(result.error || 'Save failed', true);
    } catch(e) { showToast(e.message, true); }
    setSaving(false);
  }

  if (loading) return <div style={{ padding: 48, textAlign: 'center', color: '#888' }}>Loading...</div>;
  if (error)   return <div style={{ padding: 48, textAlign: 'center', color: '#c5221f' }}>Error: {error}</div>;
  if (!data)   return <div style={{ padding: 48, textAlign: 'center', color: '#888' }}>Not found.</div>;

  const ctx         = data.context          || {};
  const ctos        = ctx.ctos              || {};
  const om          = ctx.outlet_master     || {};
  const vpa         = data.visitPhotoAssessment || ctx.visit_photo_assessment || {};
  // Sorted explicitly by check_in_at (chronological) so pin numbering is
  // deterministic and matches the gallery's numbering below.
  const checkinPins = (vpa.photos || [])
    .filter(p => p.lat && p.lng && p.checkin_valid)
    .sort((a, b) => new Date(a.check_in_at || a.date || 0) - new Date(b.check_in_at || b.date || 0))
    .map(p => {
      const dt = p.check_in_at ? new Date(p.check_in_at) : null;
      return {
        ...p,
        geocode_lat: p.lat,
        geocode_lng: p.lng,
        check_in_date: p.date || (dt ? dt.toISOString().slice(0, 10) : null),
        check_in_time: dt ? dt.toTimeString().slice(0, 5) : null,
      };
    });

  // Same merge logic the gallery below needs, lifted to component level so
  // the lightbox (rendered in a separate scope) can also look up a specific
  // photo by row_index — needed for the "Compare with matched photo" button.
  const jasperPhotosForMerge = data.jasperPhotoFileIds || ctx.jasper_photo_file_ids || [];
  const checkinNumberByRowIndex = new Map(
    checkinPins.map((p, i) => [p.row_index, i + 1])
  );
  const mergedPhotos = (vpa.photos || []).map(p => {
    const match = jasperPhotosForMerge.find(jp => jp.date === p.date && jp.van_id === p.van_id);
    return { ...p, file_id: match?.file_id || null, checkin_number: checkinNumberByRowIndex.get(p.row_index) || null };
  }).sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));

  // Signboard vs registered/trading name — deterministic check, not dependent
  // on the credit-assessment AI happening to catch it later. Normalizes out
  // common suffixes/punctuation before comparing, since an exact string match
  // is unrealistic (signboards rarely spell out "SDN BHD" etc).
  function normalizeName(s) {
    return String(s || '')
      .toUpperCase()
      .replace(/\b(SDN\.?\s*BHD\.?|BERHAD|ENTERPRISE|TRADING|SUPPLIES?)\b/g, '')
      .replace(/[^A-Z0-9]/g, '')
      .trim();
  }
  const signboardTexts = [...new Set((vpa.photos || []).map(p => p.signboard_text).filter(Boolean))];
  const namesToCheck = [om.outlet_name, ctos.entity_name].filter(Boolean).map(normalizeName);
  const signboardHasEvidence = signboardTexts.length > 0 && namesToCheck.length > 0;
  const signboardMatches = signboardHasEvidence && signboardTexts.some(txt => {
    const norm = normalizeName(txt);
    return namesToCheck.some(n => n && norm && (norm.includes(n) || n.includes(norm)));
  });
  // Small-print ownership/licensee text (e.g. "Dimiliki oleh") can clear a
  // signboard mismatch — see AssessmentPage.js for full rationale.
  const ownershipTexts = [...new Set((vpa.photos || []).map(p => p.ownership_text).filter(Boolean))];
  const ownershipHasEvidence = ownershipTexts.length > 0 && namesToCheck.length > 0;
  const ownershipMatches = ownershipHasEvidence && ownershipTexts.some(txt => {
    const norm = normalizeName(txt);
    return namesToCheck.some(n => n && norm && (norm.includes(n) || n.includes(norm)));
  });
  const signboardMismatch = signboardHasEvidence && !signboardMatches && !ownershipMatches;
  const kycDone     = !!(data.kycStatus && data.kycStatus !== '');
  const omAddress = om.address || '';

  if (maint.blocked) return <MaintenanceScreen />;
  return (
    <div style={s.page}>
      <nav style={s.nav}>
        <div style={s.navLeft}>
          <button style={s.backBtn} onClick={() => navigate('/')}>← KYC Assessment</button>
          <img
            src="/logo-wordmark.svg"
            alt="Ninja Mart"
            width={28 * 3.84}
            height={28}
            style={{ height: 28, width: 28 * 3.84, objectFit: 'contain' }}
            onError={e => { e.target.style.display = 'none'; }} />
          <div style={s.navTitle}>{data.outletId} — {data.outletName}</div>
        </div>
        <div style={{ position: 'relative' }}>
          <div
            style={{ color: 'rgba(255,255,255,0.9)', fontSize: 13, cursor: 'pointer', userSelect: 'none', textAlign: 'right' }}
            onClick={e => { e.stopPropagation(); setProfileOpen(p => !p); }}
          >
            <div style={{ fontWeight: 600, color: '#fff' }}>{user.displayName} ▾</div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)', marginTop: 1 }}>KYC Admin</div>
          </div>
          {profileOpen && (
            <div style={{
              position: 'absolute', top: '100%', right: 0, marginTop: 8,
              background: '#fff', borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
              minWidth: 160, zIndex: 100, overflow: 'hidden',
            }}>
              <button
                style={{ width: '100%', padding: '12px 16px', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer', fontSize: 13, color: '#333' }}
                onClick={e => { e.stopPropagation(); setProfileOpen(false); setLeaveModalOpen(true); }}
              >Set Leave Roster</button>
              <button
                style={{ width: '100%', padding: '12px 16px', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer', fontSize: 13, color: '#c5221f', fontWeight: 600 }}
                onClick={e => { e.stopPropagation(); logout(); }}
              >Sign out</button>
            </div>
          )}
          <LeaveRosterEntry open={leaveModalOpen} onClose={() => setLeaveModalOpen(false)} />
        </div>
      </nav>

      <div style={s.body}>

        {kycDone ? (
          <div style={{ background: '#e6f4ea', border: '1px solid #34a853', borderRadius: 8, padding: '10px 16px', marginBottom: 16, color: '#1e7e34', fontWeight: 600 }}>
            ✓ KYC {data.kycStatus} — submitted by {data.kycPreparedBy} on {data.kycPreparedDate}
          </div>
        ) : (
          <div style={{ background: '#fff4e5', border: '1px solid #f0a500', borderRadius: 8, padding: '10px 16px', marginBottom: 16, color: '#b06000', fontWeight: 600 }}>
            ⏳ KYC Pending — MC Row #{mcRow}
          </div>
        )}

        {/* Credit Request */}
        <div style={s.card}>
          <div style={s.cardTitle}>Credit Request</div>
          <div style={s.grid2}>
            <KV label="Outlet ID"            value={data.outletId} />
            <KV label="Amast Name"            value={data.outletName} />
            <KV label="Registered Name (SSM)" value={data.entityName} />
            {ctx.request?.reg_no && <KV label="SSM / Reg No." value={String(ctx.request.reg_no)} />}
            <KV label="Requested Limit" value={'RM ' + fmt(data.reqLimit)} />
            <KV label="Requestor"       value={data.requestorName} />
            <KV label="Region"          value={data.region} />
          </div>
          {data.salesRemarks && (
            (() => {
                let rm = {};
                try { rm = JSON.parse(data.salesRemarks); } catch(e) { rm = { other_remarks: data.salesRemarks }; }
                const fields = [
                  rm.limitJustification     && { label: 'Limit Justification',      value: rm.limitJustification },
                  rm.limit_justification    && { label: 'Limit Justification',      value: rm.limit_justification },
                  rm.latePaymentResponse    && { label: 'Late Payment Response',    value: rm.latePaymentResponse },
                  rm.late_payment_response  && { label: 'Late Payment Response',    value: rm.late_payment_response },
                  rm.other_remarks          && { label: 'Sales Remarks',            value: rm.other_remarks },
                  (rm.is_resubmission && rm.resubmission_reason) && { label: 'Resubmission Reason', value: rm.resubmission_reason },
                ].filter(Boolean);
                if (fields.length === 0) return null;
                return (
                  <div style={{ marginTop: 12 }}>
                    {fields.map(f => (
                      <div key={f.label} style={{ marginBottom: 8, padding: '8px 12px', background: '#f8f9fa', borderRadius: 6 }}>
                        <div style={{ fontSize: 11, color: '#888', marginBottom: 2 }}>{f.label}</div>
                        <div style={{ fontSize: 13, color: '#555', fontStyle: 'italic' }}>"{f.value}"</div>
                      </div>
                    ))}
                  </div>
                );
              })()
          )}
        </div>

        {/* SSM portal-down bypass — automation could not verify this outlet's
            registration number against SSM at submission time. The salesman
            self-certified instead; CTOS's own cached database lookup (and
            any auto-extraction relying on it) cannot be trusted to disambiguate
            a genuinely-new entity from a wrong/mistyped reg no in this case —
            requires manual CTOS extraction and manual reg-no verification. */}
        {(() => {
          if (!data.salesRemarks) return null;
          let rm = {};
          try { rm = JSON.parse(data.salesRemarks); } catch(e) { return null; }
          if (rm.portal_verified === false && rm.portal_skip_reason === 'PORTAL_DOWN') {
            return (
              <div style={{ background: '#fff4e5', border: '1px solid #ffb84d', borderRadius: 8, padding: '12px 14px', marginBottom: 16 }}>
                <div style={{ fontWeight: 600, fontSize: 13, color: '#8a5200', marginBottom: 4 }}>⚠ Manual review required — SSM registration not auto-verified</div>
                <div style={{ fontSize: 12, color: '#6b3f00', lineHeight: 1.5 }}>
                  The SSM portal was unavailable at submission time. The registration number was self-certified by the submitting salesperson and was NOT independently verified against SSM's live registry.
                  CTOS's own database lookup cannot reliably tell "genuinely new entity" apart from "wrong registration number" in this case — pull the CTOS report manually and verify the registration number against SSM before proceeding.
                </div>
              </div>
            );
          }
          return null;
        })()}
        {signboardMismatch && (
          <div style={{ background: '#fff8e1', border: '1px solid #f2c94c', borderRadius: 8, padding: '12px 14px', marginBottom: 16 }}>
            <div style={{ fontWeight: 600, fontSize: 13, color: '#8a6d00', marginBottom: 4 }}>⚠ Signboard name does not match registered name</div>
            <div style={{ fontSize: 12, color: '#6b5900', lineHeight: 1.5 }}>
              Signboard reads {signboardTexts.map(t => `"${t}"`).join(', ')}, but the registered/trading name is
              {' '}"{om.outlet_name || ctos.entity_name}". Verify whether the outlet trades under a different name,
              or whether this needs further investigation before KYC is approved.
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 8, fontSize: 12, color: '#333', cursor: 'pointer' }}>
              <input type="checkbox" checked={signboardAck} onChange={e => setSignboardAck(e.target.checked)} />
              I have reviewed this discrepancy
            </label>
          </div>
        )}

        {/* Outlet Master */}
        <div style={s.card}>
          <div style={s.cardTitle}>Outlet Master Info</div>
          <div style={s.grid2}>
            <KV label="Trading Name"  value={om.outlet_name} />
            <KV label="Channel"       value={om.channel} />
            <KV label="Current Limit" value={'RM ' + fmt(om.current_limit)} />
            <KV label="Current Term"  value={om.current_term_days ? om.current_term_days + ' days' : '—'} />
            <KV label="Visit Cycle"   value={om.visit_cycle_days ? om.visit_cycle_days + ' days' : '—'} />
            <KV label="Van ID"        value={om.van_id} />
          </div>
          {om.address && (
            <div style={{ marginTop: 10, padding: '8px 0', borderTop: '1px solid #f3f3f3', fontSize: 13 }}>
              <span style={{ color: '#666', fontSize: 12 }}>Address</span>
              <div style={{ fontWeight: 600, marginTop: 2 }}>{om.address}</div>
            </div>
          )}
        </div>

        {/* Address Comparison */}
        {(omAddress || ctos.business_addresses?.length > 0) && (
          <div style={s.card}>
            <div style={s.cardTitle}>Address Comparison</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#1967d2', marginBottom: 8 }}>OUTLET MASTER</div>
                <div style={{ fontSize: 13, color: '#333', lineHeight: 1.6 }}>{omAddress || '—'}</div>
              </div>
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#c8102e', marginBottom: 8 }}>CTOS (OFFICIAL)</div>
                {ctos.business_addresses?.length > 0
                  ? ctos.business_addresses.map((addr, i) => <AddrCompareRow key={i} addr={addr} index={i} />)
                  : <div style={{ fontSize: 13, color: '#888' }}>—</div>
                }
              </div>
            </div>
          </div>
        )}

        {/* Location + Check-in Map */}
        {om.lat && om.lng && (
          <div style={s.card}>
            <OutletMap lat={om.lat} lng={om.lng} checkinPins={checkinPins} />
          </div>
        )}
        {/* Outlet Photo — above visit photos. Up to 3, in a simple row.
            Falls back to the old singular field for rows predating this
            change, so nothing breaks for existing assessments. */}
        {(() => {
          const outletPhotos = (data.outletPhotoFileIds && data.outletPhotoFileIds.length > 0)
            ? data.outletPhotoFileIds
            : (data.outletPhotoFileId ? [data.outletPhotoFileId] : []);
          if (outletPhotos.length === 0) return null;
          return (
            <div style={s.card}>
              <div style={s.cardTitle}>Outlet Photo (Master Record)</div>
              <div style={{ display: 'flex', gap: 8 }}>
                {outletPhotos.map((fileId, i) => (
                  <img key={fileId || i} src={`/api/drive-image/${fileId}`} alt={`outlet ${i + 1}`}
                    style={{ ...s.photo, width: 'auto', flex: 1, minWidth: 0 }}
                    onError={e => e.target.style.display = 'none'} />
                ))}
              </div>
            </div>
          );
        })()}

        {(() => {
          const jasperPhotos = data.jasperPhotoFileIds || ctx.jasper_photo_file_ids || [];
          if (jasperPhotos.length === 0 && !vpa.flag) return null;

          // Reuse the component-level computation (also used by the lightbox).
          const merged = mergedPhotos;

          const VISIBLE_COUNT = 6;
          const visible = showAllPhotos ? merged : merged.slice(0, VISIBLE_COUNT);

          return (
            <div style={s.card}>
              <div style={s.cardTitle}>Visit Photos</div>
              {vpa.reference_photo_source === 'google_places_verified' && (
                <div style={{ padding: '8px 12px', background: '#fff8e1', borderRadius: 6, marginBottom: 10, fontSize: 12, color: '#8a6d00' }}>
                  ⚠ No outlet photo was on file — the reference photo used for comparison below was sourced from Google Maps and AI-verified to show this business. Capture date is unknown (not provided by Google for standard contributed photos).
                </div>
              )}
              {vpa.flag && (
                <div style={{ padding: 12, background: '#f8f9fa', borderRadius: 8, borderLeft: '4px solid ' + (vpa.flag === 'GOOD_EVIDENCE' ? '#1e7e34' : '#c5221f'), marginBottom: 14 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: vpa.flag === 'GOOD_EVIDENCE' ? '#1e7e34' : '#c5221f' }}>{vpa.flag}</div>
                  <div style={{ fontSize: 13, color: '#555', marginTop: 4 }}>{vpa.summary}</div>
                  <div style={{ fontSize: 12, color: '#888', marginTop: 6 }}>
                    {vpa.valid_checkins != null && `Valid check-ins: ${vpa.valid_checkins} / ${vpa.total_checkins}`}
                    {vpa.last_legit_checkin_date && ` | Last legit: ${vpa.last_legit_checkin_date}`}
                  </div>
                </div>
              )}
              {merged.length === 0 ? (
                <div style={{ fontSize: 13, color: '#888' }}>No visit photos available.</div>
              ) : (
                <>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 12 }}>
                    {visible.map((p, i) => (
                      <div key={i} style={{ border: '1px solid #eee', borderRadius: 8, overflow: 'hidden', background: p.checkin_valid ? '#fff' : '#fff8f8', position: 'relative' }}>
                        {p.checkin_number && (
                          <div style={{
                            position: 'absolute', top: 6, left: 6, zIndex: 1,
                            width: 22, height: 22, borderRadius: '50%', background: '#1967d2', color: '#fff',
                            fontSize: 12, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.4)',
                          }} title={`Matches Check-in ${p.checkin_number} on the map`}>
                            {p.checkin_number}
                          </div>
                        )}
                        {p.file_id ? (
                          <img src={`/api/drive-image/${p.file_id}`} alt={p.photo_type || 'visit photo'}
                            style={{ width: '100%', height: 130, objectFit: 'cover', display: 'block', cursor: 'zoom-in' }}
                            onClick={() => setEnlargedPhoto(p)}
                            onError={e => e.target.style.display = 'none'} />
                        ) : (
                          <div style={{ width: '100%', height: 130, background: '#f3f3f3', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, color: '#aaa' }}>No image</div>
                        )}
                        <div style={{ padding: 8 }}>
                          <div style={{ fontSize: 11, fontWeight: 700, color: p.checkin_valid ? '#1e7e34' : '#c5221f' }}>
                            {p.checkin_valid ? '✓ Valid check-in' : '✗ Not a valid check-in'}
                          </div>
                          {!p.checkin_valid && (
                            <div style={{ fontSize: 10, color: '#c5221f', marginTop: 1 }}>
                              {[
                                !p.is_valid_evidence && 'content',
                                p.geocode_too_far && 'too far',
                                p.geocode_implausible && 'geocode implausible',
                                p.flash_visit && 'flash visit',
                                p.possible_rephotograph && 'possible re-photograph',
                              ].filter(Boolean).join(' · ')}
                            </div>
                          )}
                          {(p.photo_type || p.note) && (
                            <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                              {p.photo_type ? p.photo_type.replace(/_/g, ' ') : ''}
                              {p.photo_type && p.note ? ' — ' : ''}
                              {p.note || ''}
                            </div>
                          )}
                          <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>{p.date} {p.van_id ? '· ' + p.van_id : ''}</div>
                          {p.lat && p.lng && (
                            <div style={{ fontSize: 10, color: (p.geocode_implausible || p.geocode_too_far) ? '#c5221f' : '#aaa', marginTop: 2 }}>
                              {p.lat}, {p.lng}
                              {p.geocode_implausible ? ` ⚠ ${p.geocode_distance_km}km from outlet` : ''}
                              {!p.geocode_implausible && p.geocode_too_far ? ` ⚠ ${p.geocode_distance_m}m from outlet` : ''}
                            </div>
                          )}
                          {p.flash_visit && (
                            <div style={{ fontSize: 10, color: '#c5221f', marginTop: 2 }}>
                              ⚠ Flash visit — {p.visit_duration_seconds}s check-in to check-out
                            </div>
                          )}
                          {p.possible_rephotograph && (
                            <div style={{ fontSize: 10, color: '#c5221f', marginTop: 2 }}>
                              ⚠ Possible re-photograph{p.rephotograph_indicators ? `: ${p.rephotograph_indicators}` : ''}
                              {p.matched_photo_row_index != null && (() => {
                                const matched = merged.find(m => m.row_index === p.matched_photo_row_index);
                                return matched ? (
                                  <div>
                                    <button onClick={() => setEnlargedPhoto(matched)}
                                      style={{ marginTop: 3, padding: '2px 8px', fontSize: 10, fontWeight: 600, color: '#1967d2', background: '#e8f0fe', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
                                      → View matched photo ({matched.date})
                                    </button>
                                  </div>
                                ) : null;
                              })()}
                            </div>
                          )}
                          {p.signboard_text && <div style={{ fontSize: 11, color: '#555', marginTop: 4 }}>🪧 {p.signboard_text}</div>}
                          {p.ownership_text && <div style={{ fontSize: 11, color: '#1e7e34', marginTop: 2 }}>📋 Ownership text: {p.ownership_text}</div>}
                        </div>
                      </div>
                    ))}
                  </div>
                  {merged.length > VISIBLE_COUNT && (
                    <button onClick={() => setShowAllPhotos(v => !v)}
                      style={{ marginTop: 12, padding: '6px 14px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 12, fontWeight: 600, color: '#555' }}>
                      {showAllPhotos ? '▲ Show less' : `▼ Show more (${merged.length - VISIBLE_COUNT} more)`}
                    </button>
                  )}
                </>
              )}
            </div>
          );
        })()}

        {/* Photo lightbox — click any visit photo above to enlarge to its
            highest available resolution. Click outside the image or the ✕
            to close. Uses object-fit: contain (not cover) so the full image
            is visible, unlike the cropped thumbnail grid above. */}
        {enlargedPhoto && (
          <div
            onClick={() => setEnlargedPhoto(null)}
            style={{
              position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              zIndex: 1000, cursor: 'zoom-out', padding: 24,
            }}
          >
            <img
              src={`/api/drive-image/${enlargedPhoto.file_id}`}
              alt={enlargedPhoto.photo_type || 'visit photo'}
              onClick={e => e.stopPropagation()}
              style={{ maxWidth: '95vw', maxHeight: '90vh', objectFit: 'contain', cursor: 'default', borderRadius: 4 }}
            />
            <button
              onClick={() => setEnlargedPhoto(null)}
              style={{
                position: 'absolute', top: 20, right: 24, background: 'rgba(255,255,255,0.15)',
                border: 'none', color: '#fff', fontSize: 22, width: 40, height: 40, borderRadius: '50%',
                cursor: 'pointer', lineHeight: '40px', textAlign: 'center',
              }}
            >×</button>
            {(enlargedPhoto.photo_type || enlargedPhoto.note) && (
              <div
                onClick={e => e.stopPropagation()}
                style={{
                  position: 'absolute', bottom: 20, left: '50%', transform: 'translateX(-50%)',
                  background: 'rgba(0,0,0,0.6)', color: '#fff', padding: '8px 16px', borderRadius: 6,
                  fontSize: 12, maxWidth: '80vw', textAlign: 'center', cursor: 'default',
                }}
              >
                <div style={{ fontWeight: 700, color: enlargedPhoto.checkin_valid ? '#7ee2a8' : '#ff9999' }}>
                  {enlargedPhoto.checkin_valid ? '✓ Valid check-in' : '✗ Not a valid check-in'}
                </div>
                {(enlargedPhoto.photo_type || enlargedPhoto.note) && (
                  <div style={{ marginTop: 2, opacity: 0.85 }}>
                    {enlargedPhoto.photo_type ? enlargedPhoto.photo_type.replace(/_/g, ' ') : ''}
                    {enlargedPhoto.photo_type && enlargedPhoto.note ? ' — ' : ''}
                    {enlargedPhoto.note || ''}
                  </div>
                )}
                {enlargedPhoto.possible_rephotograph && enlargedPhoto.matched_photo_row_index != null && (() => {
                  const matched = mergedPhotos.find(m => m.row_index === enlargedPhoto.matched_photo_row_index);
                  return matched ? (
                    <button onClick={() => setEnlargedPhoto(matched)}
                      style={{ marginTop: 6, padding: '4px 10px', fontSize: 11, fontWeight: 600, color: '#1967d2', background: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
                      → Compare with matched photo ({matched.date})
                    </button>
                  ) : null;
                })()}
              </div>
            )}
          </div>
        )}

        {/* CTOS Entity */}
        {(ctos.entity_name || ctos.entity_status) && (
          <div style={s.card}>
            <div style={s.cardTitle}>CTOS Entity</div>
            <div style={s.grid2}>
              <KV label="Entity Name" value={ctos.entity_name} />
              <KV label="Type"              value={ctos.entity_type} />
              <KV label="Status"            value={ctos.entity_status} />
              <KV label="Report Type"       value={ctos.report_type} />
              <KV label="Reg Date"          value={ctos.registration_date} />
              <KV label="Expiry"            value={ctos.expiry_date} />
              <KV label="Business Activity" value={ctos.business_activity || ctos.msic || '—'} />
            </div>
            {ctos.business_addresses?.length > 0 && (
              <div style={{ marginTop: 10 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#888', margin: '10px 0 6px' }}>ADDRESSES</div>
                {ctos.business_addresses.map((addr, i) => <AddrRow key={i} addr={addr} index={i} isFirst={i === 0} />)}
              </div>
            )}
            {ctos.owners?.length > 0 && (
              <div style={{ marginTop: 10 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#888', margin: '10px 0 6px' }}>OWNERS</div>
                {ctos.owners.map((o, i) => <KV key={i} label={o.name} value={o.position + (o.id ? ' (' + o.id + ')' : '')} />)}
              </div>
            )}
          </div>
        )}

        {/* Potential Duplicates by Outlet Name */}
        {(() => {
          const dupCheck = data.context?.duplicate_check;
          if (!dupCheck?.checked) return null;
          const amastMatches   = dupMatches.length > 0 ? dupMatches : (dupCheck.amast_matches || []);
          const obligorMatches = dupCheck.obligor_matches || [];
          // Rows needing an actual KYC decision — excludes anything already
          // resolved via Obligor (informational only, per Jun: confirmed
          // related parties already listed in Obligor don't need reflagging,
          // but are still shown).
          const needsDecision = amastMatches.filter(m => m.relation_source !== 'obligor_confirmed');
          return (
            <>
              <div style={s.card}>
                <div style={s.cardTitle}>Potential Duplicates by Outlet Name</div>
                {amastMatches.length === 0 ? (
                  <div style={{ fontSize: 13, color: '#1e7e34', padding: '8px 0' }}>✓ No potential duplicates found in Amast.</div>
                ) : (
                  <>
                    {needsDecision.length > 0 && (
                      <div style={{ fontSize: 12, color: '#b06000', marginBottom: 12 }}>
                        ⚠ Review each outlet below and confirm whether it is a Duplicate, a Related Party (different outlet, same business/owner), or Not Related. All entries must be classified before submission.
                      </div>
                    )}
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                      <thead>
                        <tr style={{ background: '#f3f5f6' }}>
                          {['Site ID','Outlet ID','Name','Address','City','Status','Distance','Decision'].map(h => (
                            <th key={h} style={{ padding: '6px 8px', textAlign: 'left', fontWeight: 600, color: '#555', borderBottom: '1px solid #e0e0e0' }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {amastMatches.map((m, i) => {
                          const isObligorConfirmed = m.relation_source === 'obligor_confirmed';
                          const rowBg = m.relation_type === 'duplicate' ? '#fff3f3'
                            : m.relation_type === 'related_party' ? '#f2f0ff'
                            : m.relation_type === 'none' ? '#f3fff5'
                            : '#fff';
                          return (
                            <tr key={m.outlet_id} style={{ borderBottom: '1px solid #f0f0f0', background: rowBg }}>
                              <td style={{ padding: '6px 8px' }}>{m.site_id}</td>
                              <td style={{ padding: '6px 8px' }}>{m.outlet_id}</td>
                              <td style={{ padding: '6px 8px', fontWeight: 600 }}>{m.name}</td>
                              <td style={{ padding: '6px 8px', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>{m.address}</td>
                              <td style={{ padding: '6px 8px' }}>{m.city}</td>
                              <td style={{ padding: '6px 8px' }}>{m.status}</td>
                              <td style={{ padding: '6px 8px' }}>{m.distance_km != null ? `${m.distance_km} km` : '—'}</td>
                              <td style={{ padding: '6px 8px' }}>
                                {isObligorConfirmed ? (
                                  <span style={{ fontWeight: 700, color: '#5b3fd4', fontSize: 11 }}>
                                    ✓ Related Party (Obligor: {m.obligor_group_name})
                                  </span>
                                ) : kycDone ? (
                                  <span style={{ fontWeight: 700, color: m.relation_type === 'duplicate' ? '#c5221f' : m.relation_type === 'related_party' ? '#5b3fd4' : '#1e7e34' }}>
                                    {m.relation_type === 'duplicate' ? '✗ Duplicate' : m.relation_type === 'related_party' ? '◆ Related Party' : m.relation_type === 'none' ? '✓ Not Related' : '—'}
                                  </span>
                                ) : (
                                  <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                                    <button onClick={() => { const u = [...(dupMatches.length > 0 ? dupMatches : amastMatches)]; u[i] = { ...u[i], relation_type: 'duplicate' }; setDupMatches(u); }}
                                      style={{ padding: '3px 8px', border: 'none', borderRadius: 4, cursor: 'pointer', fontWeight: 600, fontSize: 11, background: m.relation_type === 'duplicate' ? '#c5221f' : '#eee', color: m.relation_type === 'duplicate' ? '#fff' : '#333' }}>
                                      Duplicate
                                    </button>
                                    <button onClick={() => { const u = [...(dupMatches.length > 0 ? dupMatches : amastMatches)]; u[i] = { ...u[i], relation_type: 'related_party' }; setDupMatches(u); }}
                                      style={{ padding: '3px 8px', border: 'none', borderRadius: 4, cursor: 'pointer', fontWeight: 600, fontSize: 11, background: m.relation_type === 'related_party' ? '#5b3fd4' : '#eee', color: m.relation_type === 'related_party' ? '#fff' : '#333' }}>
                                      Related Party
                                    </button>
                                    <button onClick={() => { const u = [...(dupMatches.length > 0 ? dupMatches : amastMatches)]; u[i] = { ...u[i], relation_type: 'none' }; setDupMatches(u); }}
                                      style={{ padding: '3px 8px', border: 'none', borderRadius: 4, cursor: 'pointer', fontWeight: 600, fontSize: 11, background: m.relation_type === 'none' ? '#1e7e34' : '#eee', color: m.relation_type === 'none' ? '#fff' : '#333' }}>
                                      Not Related
                                    </button>
                                  </div>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {!kycDone && (
                      <div style={{ marginTop: 14, padding: '10px 12px', background: '#f8f9fa', borderRadius: 6 }}>
                        <div style={{ fontSize: 12, color: '#555', marginBottom: 6 }}>Know of additional duplicates not in the list above? Adjust count and note in remarks.</div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span style={{ fontSize: 12, color: '#555' }}>Additional duplicate count:</span>
                          <input type="number" min="0" value={manualExtraCount} onChange={e => setManualExtraCount(Number(e.target.value) || 0)}
                            style={{ width: 60, padding: '4px 8px', border: '1px solid #ddd', borderRadius: 4, fontSize: 12 }} />
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
              {obligorMatches.length > 0 && (
                <div style={s.card}>
                  <div style={s.cardTitle}>Related Parties (Obligor)</div>
                  <div style={{ fontSize: 12, color: '#555', marginBottom: 10 }}>These outlets share the same group / ownership as the assessment outlet. For credit risk reference only.</div>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                    <thead>
                      <tr style={{ background: '#f3f5f6' }}>
                        {['Outlet ID','Name','Group'].map(h => (
                          <th key={h} style={{ padding: '6px 8px', textAlign: 'left', fontWeight: 600, color: '#555', borderBottom: '1px solid #e0e0e0' }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {obligorMatches.map(m => (
                        <tr key={m.outlet_id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                          <td style={{ padding: '6px 8px' }}>{m.outlet_id}</td>
                          <td style={{ padding: '6px 8px', fontWeight: 600 }}>{m.name}</td>
                          <td style={{ padding: '6px 8px', color: '#888' }}>{m.group_name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          );
        })()}

        {/* Historical Credit Requests */}
        {ctx.historical_underwriting?.length > 0 && (
          <div style={s.card}>
            <div style={s.cardTitle}>Historical Credit Requests ({ctx.historical_underwriting.length} records)</div>
            <div style={{ fontSize: 11, color: '#888', marginBottom: 8 }}>Click a row to expand full remarks and details</div>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ background: '#f8f9fa' }}>
                    {['','Submission Date','Requested','Outcome','Approval Date'].map(h => (
                      <th key={h} style={{ padding: '5px 8px', border: '1px solid #eee', textAlign: 'left', fontWeight: 600 }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {ctx.historical_underwriting.map((h, i) => {
                    const isOpen = expandedHistorical.has(i);
                    const submitted = h.submitted_at
                      ? (h.submitted_at.includes('T') ? h.submitted_at.split('T')[0].split('-').reverse().join('/') : h.submitted_at.split(' ')[0].split('/').reverse().join('/'))
                      : '—';

                    let outcomeLabel = '—', outcomeColor = '#888';
                    if (h.decision_type === 'credit_approved') {
                      outcomeLabel = `Approved${h.approved_limit ? ' - RM ' + Number(h.approved_limit).toLocaleString() : ''}`;
                      outcomeColor = '#1e7e34';
                    } else if (h.decision_type === 'kyc_rejected') {
                      outcomeLabel = 'L2 Rejected';
                      outcomeColor = '#c5221f';
                    } else if (h.decision_type === 'kyc_approved_pending_credit') {
                      outcomeLabel = 'L2 Approved (pending limit)';
                      outcomeColor = '#b06000';
                    } else if (h.decision_type === 'kyc_l1_rejected') {
                      outcomeLabel = 'L1 Rejected';
                      outcomeColor = '#c5221f';
                    }

                    const hasL1 = h.kyc_status || h.kyc_recommendation || h.kyc_remarks || h.rejection_reason;
                    const hasL2 = h.kyc_l2_status || h.kyc_l2_approver || h.kyc_l2_rejection_reason || h.kyc_l2_remarks;
                    const hasLimit = h.approved_limit || h.approver_remarks || h.credit_approver;

                    return (
                      <React.Fragment key={i}>
                        <tr
                          style={{ background: i % 2 === 0 ? '#fff' : '#fafafa', cursor: 'pointer' }}
                          onClick={() => setExpandedHistorical(prev => {
                            const next = new Set(prev);
                            next.has(i) ? next.delete(i) : next.add(i);
                            return next;
                          })}
                        >
                          <td style={{ padding: '4px 8px', border: '1px solid #eee', color: '#888', width: 16 }}>{isOpen ? 'v' : '>'}</td>
                          <td style={{ padding: '4px 8px', border: '1px solid #eee', whiteSpace: 'nowrap' }}>{submitted}</td>
                          <td style={{ padding: '4px 8px', border: '1px solid #eee' }}>{h.requested_limit ? 'RM ' + Number(h.requested_limit).toLocaleString() : '—'}</td>
                          <td style={{ padding: '4px 8px', border: '1px solid #eee', fontWeight: 600, color: outcomeColor }}>{outcomeLabel}</td>
                          <td style={{ padding: '4px 8px', border: '1px solid #eee', whiteSpace: 'nowrap' }}>{h.review_date || '—'}</td>
                        </tr>
                        {isOpen && (
                          <tr style={{ background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                            <td colSpan={5} style={{ padding: '10px 16px', border: '1px solid #eee' }}>
                              {h.sales_remarks && (
                                <div style={{ marginBottom: 10 }}>
                                  <div style={{ fontSize: 11, fontWeight: 700, color: '#555', marginBottom: 2 }}>SALES REMARK</div>
                                  <div style={{ color: '#333' }}>{h.sales_remarks}</div>
                                </div>
                              )}
                              {hasL1 && (
                                <div style={{ marginBottom: 10 }}>
                                  <div style={{ fontSize: 11, fontWeight: 700, color: '#555', marginBottom: 2 }}>
                                    L1 KYC — <span style={{ color: h.kyc_status === 'Pass' ? '#1e7e34' : h.kyc_status === 'Fail' ? '#c5221f' : '#b06000' }}>{h.kyc_status || h.kyc_recommendation || '-'}</span>
                                  </div>
                                  <div style={{ color: '#333' }}>{h.rejection_reason || h.kyc_remarks || '—'}</div>
                                </div>
                              )}
                              {hasL2 && (
                                <div style={{ marginBottom: 10 }}>
                                  <div style={{ fontSize: 11, fontWeight: 700, color: '#555', marginBottom: 2 }}>
                                    L2 KYC — <span style={{ color: h.kyc_l2_status === 'Approve' ? '#1e7e34' : h.kyc_l2_status === 'Reject' ? '#c5221f' : '#b06000' }}>{h.kyc_l2_status || '-'}</span>
                                    {h.kyc_l2_approver && <span style={{ fontWeight: 400, color: '#888' }}> ({h.kyc_l2_approver})</span>}
                                  </div>
                                  <div style={{ color: '#333' }}>{h.kyc_l2_rejection_reason || h.kyc_l2_remarks || '—'}</div>
                                </div>
                              )}
                              {hasLimit && (
                                <div>
                                  <div style={{ fontSize: 11, fontWeight: 700, color: '#555', marginBottom: 2 }}>
                                    LIMIT DECISION{h.approved_limit ? <span style={{ color: '#1e7e34' }}> — RM {Number(h.approved_limit).toLocaleString()}</span> : ''}
                                  </div>
                                  <div style={{ color: '#333' }}>{h.approver_remarks || '—'}</div>
                                  {h.credit_approver && <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>Approved by {h.credit_approver}</div>}
                                </div>
                              )}
                              {!h.sales_remarks && !hasL1 && !hasL2 && !hasLimit && (
                                <div style={{ color: '#888' }}>No further details recorded for this submission.</div>
                              )}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* KYC Checklist */}
        {data.kycPreparedBy && data.kycPreparedBy.startsWith('System') && (
          <div style={{ background: '#fff4e5', border: '1px solid #ffb84d', borderRadius: 8, padding: '12px 16px', marginBottom: 12 }}>
            <div style={{ fontWeight: 700, fontSize: 13, color: '#8a5200', marginBottom: 4 }}>
              [!] CTOS Not Extracted - Name Check Failed
            </div>
            <div style={{ fontSize: 13, color: '#6b3f00', lineHeight: 1.5 }}>
              CTOS extraction for this outlet was deliberately skipped because {data.kycChecks?.kyc_remarks || 'of a failed name check'}.
            </div>
          </div>
        )}
        <div style={{ ...s.card, border: kycDone ? '1.5px solid #34a853' : '1.5px solid #f0a500' }}>
          <div style={s.cardTitle}>
            KYC Checklist
            {kycDone && <span style={{ color: '#1e7e34', marginLeft: 8, textTransform: 'none', letterSpacing: 0, fontWeight: 700 }}>✓ {data.kycStatus}</span>}
          </div>
          <ToggleCheck label="R · BRN / Outlet ID Check" value={checks.brn_check}       onChange={v => setCheck('brn_check', v)}       readonly={kycDone} />
          <ToggleCheck label="S · Entity Status Check"   value={checks.entity_status}   onChange={v => setCheck('entity_status', v)}   readonly={kycDone} />
          <ToggleCheck label="T · Geocode Check"         value={checks.geocode_check}   onChange={v => setCheck('geocode_check', v)}   readonly={kycDone} />
          <ToggleCheck label="U · Duplicate Check"       value={checks.duplicate_check} onChange={v => setCheck('duplicate_check', v)} readonly={kycDone} />
          <div style={{ padding: '10px 0', borderBottom: '1px solid #f3f3f3' }}>
            <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 6 }}>W · Count Duplicate Name</label>
            <input type="number" min="0" style={{ ...s.input, width: 120, background: kycDone ? '#f8f9fa' : '#fff' }}
              value={checks.duplicate_count} onChange={e => !kycDone && setCheck('duplicate_count', e.target.value)}
              readOnly={kycDone} placeholder="e.g. 0" />
          </div>
          <div style={{ padding: '10px 0', borderBottom: '1px solid #f3f3f3' }}>
            <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 6 }}>X · KYC Status *</label>
            <select style={{ ...s.select, background: kycDone ? '#f8f9fa' : '#fff' }}
              value={checks.kyc_status} onChange={e => !kycDone && setCheck('kyc_status', e.target.value)} disabled={kycDone}>
              <option value="">— Select —</option>
              <option value="Pass">Pass</option>
              <option value="Fail">Fail</option>
              <option value="Escalate">Escalate</option>
            </select>
          </div>
          <div style={{ padding: '10px 0' }}>
            <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 6 }}>
              Y · {checks.kyc_status === 'Reject' ? 'Rejection Reason *' : 'Remarks (optional)'}
            </label>
            <textarea style={{ ...s.textarea, background: kycDone ? '#f8f9fa' : '#fff' }}
              value={checks.kyc_remarks} onChange={e => !kycDone && setCheck('kyc_remarks', e.target.value)}
              readOnly={kycDone} placeholder={checks.kyc_status === 'Reject' ? 'State reason for rejection...' : 'Any remarks...'} />
          </div>
          <div style={{ fontSize: 12, color: '#888', marginTop: 8 }}>
            Z · Prepared by: <strong>{kycDone ? data.kycPreparedBy : user.displayName}</strong>
            {' · '}{kycDone ? data.kycPreparedDate : new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
          </div>
        </div>

      </div>

      {!kycDone && (
        <div style={s.decBar}>
          {user.email === data.requestorEmail ? (
            <div style={{ fontSize: 13, color: '#c5221f', fontWeight: 600 }}>
              ⛔ You submitted this request — a different person must perform the L1 KYC check.
            </div>
          ) : (
            <button style={{ ...s.btn, background: allChecksComplete() ? '#1967d2' : '#ccc', color: '#fff', minWidth: 200 }}
              onClick={() => allChecksComplete() ? setModal(true) : showToast('Complete all checks first', true)}>
              Submit KYC Validation
            </button>
          )}
        </div>
      )}

      {toast.msg && (
        <div style={{ position: 'fixed', bottom: 80, left: '50%', transform: 'translateX(-50%)', background: toast.isError ? '#c5221f' : '#1e7e34', color: '#fff', padding: '12px 24px', borderRadius: 8, fontWeight: 600, fontSize: 14, zIndex: 300 }}>
          {toast.msg}
        </div>
      )}

      {modal && (
        <div style={s.overlay} onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div style={s.modal}>
            <div style={s.modalTitle}>Confirm KYC Submission</div>
            <div style={{ fontSize: 13, color: '#555', marginBottom: 16 }}>
              Submitting KYC decision for <strong>{data.outletId} — {data.outletName}</strong>
            </div>
            <div style={{ background: '#f8f9fa', borderRadius: 8, padding: '12px 14px', fontSize: 13 }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                {[
                  ['BRN Check (R)',     checks.brn_check       === true ? '✓ Pass' : checks.brn_check === false ? '✗ Fail' : '—'],
                  ['Entity Status (S)', checks.entity_status   === true ? '✓ Pass' : checks.entity_status === false ? '✗ Fail' : '—'],
                  ['Geocode (T)',       checks.geocode_check   === true ? '✓ Pass' : checks.geocode_check === false ? '✗ Fail' : '—'],
                  ['Duplicate (U)',     checks.duplicate_check === true ? '✓ Pass' : checks.duplicate_check === false ? '✗ Fail' : '—'],
                  ['Dup Count (W)',     checks.duplicate_count || '0'],
                  ['Status (X)',        checks.kyc_status],
                ].map(([l, v]) => (
                  <div key={l}>
                    <span style={{ color: '#888', fontSize: 11 }}>{l}</span><br />
                    <strong style={{ color: v?.includes('Fail') ? '#c5221f' : v?.includes('Pass') ? '#1e7e34' : '#333' }}>{v}</strong>
                  </div>
                ))}
              </div>
              {checks.kyc_remarks && (
                <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid #eee', fontSize: 13, color: '#555', fontStyle: 'italic' }}>
                  "{checks.kyc_remarks}"
                </div>
              )}
            </div>
            <div style={s.modalBtns}>
              <button style={{ ...s.btn, flex: 2, background: '#1967d2', color: '#fff' }} onClick={handleSubmit} disabled={saving}>
                {saving ? 'Saving...' : 'Confirm Submit'}
              </button>
              <button style={{ ...s.btn, flex: 1, background: '#eee', color: '#333' }} onClick={() => setModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}